module.exports = __webpack_public_path__ + "img/banner-jet-aghsat.b56deb39.jpg";